<template>
    <div>
      <div class="row justify-content-center">
                          <div class=" col-sm-12 grid-margin stretch-card">

                            <div class="card">
                              <div class="card-tile text-center p-2"><h2 class="">Blacklisted {{ users.length }} Clients</h2></div>
                              <div class="card-body text-center">
                                <ul class="nav nav-pills nav-fill">
      <li class="nav-item">
        <a class="nav-link "  href="#" v-on:click="routerToOtherPage('clients')">Airtime Purchasers (0)</a>
      </li>
      <li class="nav-item">
        <a class="nav-link " v-on:click="routerToOtherPage('clients2')"  aria-current="page" href="#" >Airtime Converters (0)</a>
      </li>
      <li class="nav-item">
    <a class="nav-link text-danger active" href="#" >Blacklisted Clients({{ users.length }})</a>
  </li>

    </ul>
                                <div class="mb-3 row justify-content-center">
                                  <div class="col-sm-6 float-right">
                                  <input type="text" v-model="message.filterval"  v-on:keyup="filter()" class="form-control" placeholder="Type to start filtering">
                                  </div>
                                  <div class="col-sm-3 float-right">
                                <a class="btn btn-success" v-on:click="ShowModal()">Add Blacklist</a>
                               </div>
                                </div>
                                <div class="table-responsive p-0">
                    <table class="table align-items-center mb-0">
                      <thead>
                        <tr class="text-center">
                          <th class="text-uppercase  text-xxs font-weight-bolder">#</th>
                          <th class=" text-uppercase  text-xxs font-weight-bolder ">Phone</th>
                          <th class=" text-uppercase  text-xxs font-weight-bolder ">Email</th>
                           <th class=" text-uppercase  text-xxs font-weight-bolder ">Comment</th>
                          <th class=" text-uppercase  text-xxs font-weight-bolder ">Date</th>
                          <th class=" text-uppercase  text-xxs font-weight-bolder ">Action</th>

                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(data,index) in pageOfItems" :key="data.id" class="text-center">
                          <td>
                            {{index+1}}
                          </td>
                          <td class="text-danger">
                            {{data.phone}}
                          </td>
                          <td class="text-danger">
                            {{data.phone}}
                          </td>
                           <td >
                           {{data.comment}}
                          </td>
                          <td >
                           {{filerDate(data.created_at)}}
                          </td>
                          <td>
                         <a href="#" v-on:click="removeConfirmNumber(data.id)" class=""><i class="fa fa-remove fa-2x text-danger"></i></a>
                      </td>

                        </tr>

                      </tbody>
                    </table>
                  </div>
                  <div class="row mt-4 justify-content-center">
                        <div class="col-sm-12">
                            <jw-pagination :items="users"  @changePage="onChangePage" ></jw-pagination>
                        </div>
                    </div>

                              </div>
                            </div>




                            </div>
                            </div>
                            <div class="modal fade" id="add" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">

      <div class="modal-body">
         <h6 class="text-center">Add Number to Blacklist-No transaction will be made.</h6>

         <div class="form-group mt-3">
                    <label class="form-label">Phone or Email</label>
                    <input type="text" v-model="message.phone" class="form-control" required>
                  </div>
                  <div class="form-group mt-3">
                    <label class="form-label">Comment</label>
                   <textarea class="form-control" rows="8" v-model="message.comment"></textarea>
                  </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-success" v-on:click="BlacklistClient()">Send Request</button>
      </div>
    </div>
  </div>
</div>
    </div>
    </template>
    <script>
        import moment from 'moment'
        export default {
            name: 'App',
            components: {

            },
            data(){
                return {
                users:[],
                 users2:[],
                message:{},
                 pageOfItems:[],

                }
            },
            created(){
                  this.Users();
            },
            methods: {
                removeConfirmNumber(id){
            this.$swal({
             title: 'Are you sure youi want to delete this number-',
              text: "You won't be able to revert this!",
              icon: 'warning',
             showCancelButton: true,
               confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
               confirmButtonText: 'Yes, delete it!'
              }).then((result) => {
               if (result.isConfirmed) {
                   this.removeBlacklistedNumber(id);
                 }
            })

          },
          removeBlacklistedNumber(id){
            this.$loading(true)
               let uri =`/api/auth/removeBlacklistedNumber/${id}`;
                this.axios.get(uri, { headers: { Authorization: 'Bearer '+localStorage.getItem('token')}}).then((response) => {
                    this.$loading(false)
                   if(response.data.status){
                   this.$toast.open({message: response.data.message, type: 'success', position: 'top'});
                   this.Users();
                   }else{
                   this.$toast.open({message: response.data.message, type: 'error', position: 'top'});
                   }
                }).catch(error => {
                   this.$loading(false)
                    if (error.response.status === 401) {
                    this.$router.push({name: 'index'});
                    this.$toast.open({message: 'Please sign in!', type: 'error', position: 'top'});

                }else{
                    this.$toast.open({message: 'Something went wrong!.', type: 'error', position: 'top'});
                }

                });

          },
              ShowModal(){
                this.message={};
                 $('#add').modal('show');
              },
              onChangePage(pageOfItems) {
                this.pageOfItems = pageOfItems;
            },
            routerToOtherPage(val){
            this.$router.push({name: val});
          },
          BlacklistClient(){
                $('#add').modal('hide');
                 this.$loading(true)
                   let uri =`/api/auth/BlacklistClient`;
                    this.axios.post(uri,this.message, { headers: { Authorization: 'Bearer '+localStorage.getItem('token')}}).then((response) => {
                        this.$loading(false)
                       if(response.data.status){
                       this.$toast.open({message: response.data.message, type: 'success', position: 'top'});
                       this.Users();
                       }else{
                       this.$toast.open({message: response.data.message, type: 'error', position: 'top'});
                       }
                    }).catch(error => {
                       this.$loading(false)
                        if (error.response.status === 401) {
                        this.$router.push({name: 'index'});
                        this.$toast.open({message: 'Please sign in!', type: 'error', position: 'top'});

                    }else{
                        this.$toast.open({message: 'Something went wrong!.', type: 'error', position: 'top'});
                    }

                    });
              },
                Users(){
                    this.$loading(true)
                    let uri =`/api/auth/getBlacklist`;
                    this.axios.get(uri, { headers: { Authorization: 'Bearer '+localStorage.getItem('token')}}).then((response) => {
                        this.$loading(false)
                        this.users=response.data;
                       this.users2=response.data;
                    }).catch(error => {
                        this.$loading(false)
                        if (error.response.status === 401) {
                        this.$router.push({name: 'index'});
                        this.$toast.open({message: 'Please sign in!', type: 'error', position: 'top'});

                    }else{
                        this.$toast.open({message: 'Something went wrong!.', type: 'error', position: 'top'});
                    }

                    });
                },

         filter(){
                let filterval=this.message.filterval;
                if(filterval==='' || filterval===null){
                    this.users=this.users2;
                }else{
                    let ads =  this.users2.filter(function(product) {
                        return product.phone.toLowerCase().includes(filterval.toLowerCase())
                    });
                    this.users=ads;
                }
            },
                formatPrice(value) {
                    let val = (value/1).toFixed(2).replace('.', '.');
                    return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                },
                filerDate(date){
                    return moment(String(date)).format('MM/DD/YYYY HH:mm')
                }

            },
        }

    </script>
